import React, { Component } from 'react'
import { Loading} from 'element-react';
import QueryStepBar from "../../components/queryStepBar";
import cusUtilFn from "../../utils/cusUtilFn"
import _hbzwfwJssdk from "../../utils/hbzwfwJssdk"
const hbzwfwJssdk = window.hbzwfwJssdk;
class detail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEhuiBan:true,
      title:"老年人优待证办理",
      fitrange:"武汉市",
      stepData:['校验信息','提交申请','查看状态'],
      curstep:2, //导航条
      conData:{},
      isloading:true
    }
  }
  componentDidMount() {
    let that=this,res=this.props.location.state;
    if(!!!res) return
    const obj=res;
    let result=obj.resdata.result,
    cardno=obj.resdata.cardno;
    that.syncGetDetail(cardno)
    that.setState({cardno})
  }
  //身份证异步获取证件信息
  syncGetDetail(cardno){
      let that=this;
      let param={
          cardno: cardno
       }
       _hbzwfwJssdk.requestHeaderNewWork(
        `/0ea5cc8f28dd44b59394bed6abe2df81`,
        "post",
        {'X-hbzw-Api-Key':'7fe2ef0f-9789-4229-8c68-77e1373aede6'},
        param,
        (res) => {
          let resdata=res.data;
          let tempArr=resdata.orgnamepath.split('/');
          that.setState({
            conData:resdata,
            orgnamepath_showLen:tempArr[3].length,
            isloading:false
          })
        },
        (error) => {
          console.log(error,"error") 
        }
     )
   }
  
  render() {
    let {conData,cardno,orgnamepath_showLen,isloading}=this.state;
    let DOM = 
    <div className="dataBox mt30">
      <Loading loading={isloading}>
        <table className="el-table cus-table">
         <tbody>
          <tr>
            <th><div className="cell">姓 名</div></th>
            <td><div className="cell">{cusUtilFn.hideByplusXing(conData.name,0,1)}</div></td>
            <th><div className="cell">办证类型</div></th>
            <td><div className="cell">{conData.gt12005_desc}</div></td>
          </tr>
          <tr>
            <th><div className="cell">证件号码</div></th>
            <td><div className="cell">{cusUtilFn.hideByplusXing(cardno,0,4)}</div></td>
            <th><div className="cell">办证来源</div></th>
            <td><div className="cell">{conData.gt12029}</div></td>
          </tr>
          <tr>
            <th><div className="cell">性 别</div></th>
            <td><div className="cell">{conData.gender==="1"?'男':'女'}</div></td>
            <th><div className="cell">办理状态</div></th>
            <td><div className="cell">{conData.gt12011_desc}</div></td>
          </tr>
          <tr>
           <th><div className="cell">联系电话</div></th>
           <td><div className="cell">{cusUtilFn.isFixedTelAvailable(conData.phone)===2?(conData.phone.charAt(3)==='-'?cusUtilFn.hideByplusXing(conData.phone,3,4):cusUtilFn.hideByplusXing(conData.phone,4,4)):cusUtilFn.hideByplusXing(conData.phone,3,4)}</div></td>
           <th><div className="cell">经办时间</div></th>
          <td><div className="cell">{conData.gt12009}</div></td>
          </tr>
          <tr> 
            <th><div className="cell">回卡地址</div></th>
            <td><div className="cell">{cusUtilFn.hideByplusXing(conData.orgnamepath,0,orgnamepath_showLen)}</div></td>
            <th><div className="cell">发卡状态</div></th>
            <td><div className="cell">{conData.gt12015}</div></td>
          </tr>
          </tbody>
        </table>
      </Loading>
    </div>
    return (
      <div className="cusStl oldmanAccredit w-auto">
        <div className="navBar">
          <div className="navBar_text"> {this.state.title}</div>
        </div>
        <QueryStepBar datas={this.state.stepData} curstep={this.state.curstep}/>

          <div className="contain"> 
            {!!conData?DOM:(<div className="noDataBox"><img src={require("../../assets/noSuccessImg@3x.png")}></img><span>暂未查询到办理信息</span></div>)
          }
          </div>
     
      </div>
    )

  }
}

export default detail